import { Utils } from "../../../../../../services/utils.service";
import { DataCollection } from "../../../../../infrastructure/datacollection";
import { DataContainerService } from "../../../../../infrastructure/datacontainer.service";
import { RequestTypes } from "../../../../../infrastructure/enums";
import { TransportData } from "../../../../../infrastructure/transportdata";

export class DistrictFetchRequest {
    // public static readonly FetchRequestType: string = "DistrictZoneAssociationMasterFetchRequest";
    public static readonly FetchRequestType: string = "district_master_fetch_request";
    zone_ids: number[] = [];
    district_ids: number[] = [];
    with_zone: number = 0

    public MergeIntoTransportData = (td: TransportData) => {
        let coll = DataContainerService.GetInstance().GetOrCreateCollection(td.MainData, DistrictFetchRequest.FetchRequestType) as DataCollection;
        coll.Entries.push(this);
    }

    public FormulateTransportData = () => {
        let td = Utils.GetInstance().CreateNewTransportData(RequestTypes.Fetch);
        this.MergeIntoTransportData(td);

        return td;
    }
}

